import React from 'react';
import styled from 'styled-components';
import { ClinicLocation } from '../../../common/model/dto/clinic-location';
import { UserInfo } from '../../../common/model/dto/user-info';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';
import { useAppSelector } from '../../../redux/hooks';
import OvLoadingIndicator from '../atoms/OvLoadingIndicator';
import OvUserCharts, { DailyDataRange } from './OvUserCharts';
import { ClinicLocationService } from '../../../services/clinic-location.service';
import queryString from 'query-string';
import { endOfDay, startOfDay } from 'date-fns';

const OvPatientOwnResults = () => {
  const currentUser: UserInfo | undefined = useAppSelector(
    (state) => state.user.currentUser
  );
  const selectedClinicLocation: ClinicLocation | undefined = useAppSelector(
    (state) => state.user.selectedClinicLocation
  );
  const isLoading = useAppSelector((state) => state.user.isLoading);

  const fetchOwnDailyData = async ({ startDate, endDate }: DailyDataRange) => {
    const query = queryString.stringify({
      limit: 0,
      start_date: startOfDay(startDate).toISOString(),
      end_date: endOfDay(endDate).toISOString(),
    });

    const paginated = await ClinicLocationService.getOwnDailyDataByQuery(query);

    return paginated.docs;
  };

  const fetchOwnCalendarDailyData = async ({
    startDate,
    endDate,
  }: DailyDataRange) => {
    const query = queryString.stringify({
      order_by: 'created_at',
      order_dir: 'asc',
      created_at_from: startDate.toISOString(),
      created_at_to: endDate.toISOString(),
      limit: 100,
    });

    const paginated = await ClinicLocationService.getOwnDailyDataByQuery(query);

    return paginated.docs;
  };

  return (
    <>
      {currentUser && selectedClinicLocation && (
        <DetailPageWrapper>
          <Header>
            <LeftInfoWrapper>
              <UserName>
                {`${currentUser?.first_name} ${currentUser?.last_name}`}
                <StyledEmail>{currentUser?.email}</StyledEmail>
              </UserName>
            </LeftInfoWrapper>
          </Header>
          <OvUserCharts
            user={currentUser}
            fetchDailyData={fetchOwnDailyData}
            dailyDataQueryKey={['own-daily-data', currentUser.id]}
            fetchCalendarDailyData={fetchOwnCalendarDailyData}
            calendarDailyDataQueryKey={['own-daily-data-range', currentUser.id]}
          />
        </DetailPageWrapper>
      )}
      {isLoading && <OvLoadingIndicator position="fixed" />}
    </>
  );
};

export default OvPatientOwnResults;

const DetailPageWrapper = styled.div`
  margin-left: 1rem;
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  font-weight: bold;
`;

const UserName = styled.h6`
  margin: 0;
  font-weight: bold;
  font-size: ${Variables.fontSizes.LARGE};
`;

const StyledEmail = styled.span`
  border-left: 1px solid ${Colours.OV_BASE_HOVER};
  margin-left: 0.75rem;
  padding-left: 0.75rem;
`;

const LeftInfoWrapper = styled.div`
  display: flex;
  align-items: center;
`;
